import { PropertyComponentTypeahead } from './../../../shared/models/typeahead/property-component-typeahead';
import { TypeaheadPropertyComponentComponent } from './../../../shared/components/typeahead-property-component';
import {
  Component,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FiscalYear } from '../../../shared/models/fiscal-year';
import { PropertyFile } from '../../shared/models/property-file';
import { FileAssignComponentsRequest } from '../../shared/models/file-assign-components-request';

@Component({
  selector: 'sp-file-assign-component-modal',
  templateUrl: './file-assign-component-modal.component.html',
  styleUrls: ['./file-assign-component-modal.component.scss'],
  standalone: false
})
export class FileAssignComponentModalComponent implements AfterViewInit, OnChanges {
  @ViewChild(ModalDirective, { static: true }) public bsModal: ModalDirective;
  @ViewChild('componentTypeahead', { static: true }) public componentTypeahead: TypeaheadPropertyComponentComponent;

  @Input() propertyId: string;
  @Input() fiscalYear: FiscalYear;
  @Input() files: PropertyFile[];

  @Output() onConfirm: EventEmitter<FileAssignComponentsRequest> = new EventEmitter<FileAssignComponentsRequest>();

  currentComponents: PropertyComponentTypeahead[];
  addedComponents: PropertyComponentTypeahead[];
  removedComponents: PropertyComponentTypeahead[];

  ngAfterViewInit() {
    this.bsModal.config.keyboard = false;
    this.bsModal.config.ignoreBackdropClick = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['files'] && this.files) {
      this.setCurrentComponents();
    }
  }

  show(): void {
    this.bsModal.show();
    this.setCurrentComponents();
  }

  closeModal(): void {
    this.bsModal.hide();
    this.componentTypeahead.clearSearch();
    this.currentComponents = null;
    this.addedComponents = null;
    this.removedComponents = null;
  }

  setCurrentComponents() {
    this.currentComponents = [];

    if (this.files == null) { return; }

    this.files.forEach((file) => {
      if (file != null) {
        file.propertyComponents.forEach( (c) => {
          if (this.currentComponents.findIndex((x) => x.propertyComponentId === c.propertyComponentId) < 0) {
            this.currentComponents.push({ propertyComponentId: c.propertyComponentId, name: c.name, categoryName: null });
          }
        });
      }
    });
  }

  getCurrentUnchangedComponents() {
    if (this.removedComponents == null || this.removedComponents.length === 0) {
      return this.currentComponents;
    }
    return this.currentComponents.filter(c => this.removedComponents.indexOf(c) < 0);
  }

  addSelectedComponent(component: PropertyComponentTypeahead) {
    if (this.addedComponents == null) {
      this.addedComponents = [];
    }

    const index = this.addedComponents.find((c) => c.propertyComponentId === component.propertyComponentId);

    if (index == null) {
      this.addedComponents.push(component);
    }

    this.componentTypeahead.clearSearch();
  }

  removeSelectedComponentFromCurrent(component: PropertyComponentTypeahead) {
    if (this.removedComponents == null) {
      this.removedComponents = [];
    }

    const index = this.removedComponents.find((c) => c.propertyComponentId === component.propertyComponentId);
    if (index == null) {
      this.removedComponents.push(component);
    }
  }

  removeSelectedComponentFromAdded(component: PropertyComponentTypeahead) {
    const index = this.addedComponents.indexOf(component);

    if (index >= 0) {
      this.addedComponents.splice(index, 1);
    }
  }

  removeSelectedComponentFromRemoved(component: PropertyComponentTypeahead) {
    const index = this.removedComponents.indexOf(component);

    if (index >= 0) {
      this.removedComponents.splice(index, 1);
    }
  }

  assignComponent() {
    const fileIds = this.files.map((c) => c.propertyFileId);
    const addedComponentIds = !this.addedComponents ? null : this.addedComponents.map((c) => c.propertyComponentId);
    const removedComponentIds = !this.removedComponents ? null : this.removedComponents.map((c) => c.propertyComponentId);

    const request = new FileAssignComponentsRequest(this.propertyId, fileIds, addedComponentIds, removedComponentIds);
    this.onConfirm.emit(request);
    this.closeModal();
  }
}
